import type { IChooseProfile } from './index.h'

import { ButtonIconSizes, IconPositions } from 'atoms/Button'
import { IconNames } from 'atoms/Icon'
import { TextAligning } from 'atoms/TextBox'
import { TextBoxMaxLine2Font4xlBold } from 'atoms/TextBox/Templates'
import { FIXED_INDENTS } from 'vars/fixed-indents'
import {
  BackButtonSC,
  ChooseProfileAvatarsSC,
  ChooseProfileSC,
} from './ChooseProfile.styled'

export const ChooseProfile = ({
  title = '',
  children,
  onBack,
}: IChooseProfile) => {
  return (
    <ChooseProfileSC>
      {onBack && (
        <BackButtonSC
          icon={IconNames.arrowLeft}
          iconPosition={IconPositions.Center}
          iconSize={ButtonIconSizes.xSm}
          paddings={[
            FIXED_INDENTS.INDENT_30,
            FIXED_INDENTS.INDENT_30,
            FIXED_INDENTS.INDENT_30,
            FIXED_INDENTS.INDENT_30,
          ]}
          onClick={onBack}
        />
      )}
      <TextBoxMaxLine2Font4xlBold
        title={title}
        alignment={TextAligning.Center}
      />
      <ChooseProfileAvatarsSC>{children}</ChooseProfileAvatarsSC>
    </ChooseProfileSC>
  )
}
